<template>
  <div class="joditBox" :class="editorClass">
    <jodit-vue
      v-model="joditContent"
      :config="useFileUploadAXZ ? axzEditorOption.configs : editorOption.configs"
      :buttons="useFileUploadAXZ ? axzEditorOption.buttons : editorOption.buttons"
      :events="useFileUploadAXZ ? axzEditorOption.events : editorOption.events"
      :useFileUpload="useFileUpload"
      :useFileUploadAXZ="useFileUploadAXZ"
    />
    <input type="hidden" v-model="value" />
  </div>
</template>

<script>
import Helpers from '@/util/helpers';
import JoditVue from '@/components/JoditVue';
import { mapGetters } from 'vuex';

export default {
  name: 'jodit-editor',
  components: {
    JoditVue
  },
  props: {
    value: {
      type: String,
      default: '',
      required: false
    },
    setConfigs: {
      type: Object,
      default: () => ({}),
      required: false
    },
    editorClass: {
      type: String,
      default: '',
      required: false
    },
    useFileUpload: {
      type: Boolean,
      default: true,
      required: false
    },
    useFileUploadAXZ: {
      type: Boolean,
      default: false,
      required: false
    },
    brandId: {
      type: [String, Number],
      default: () => null,
      required: false
    },
    apiURL: {
      type: String,
      default: '/api/external/multiFileSingleUpload',
      required: false
    }
  },
  watch: {
    value(val) {
      this.joditContent = val;
    },
    joditContent(val) {
      this.$emit('input', val);
    },
    brandId(value) {
      if (value) {
        this.mergeConfig();
      }
    },
    useFileUploadAXZ() {
      this.mergeConfig();
    }
  },
  data() {
    return {
      joditContent: ''
    };
  },
  computed: {
    ...mapGetters(['agentId', 'loginId', 'displayingChatRoomId']),
    useExternalFileUploadAPI() {
      return this.apiURL === '/api/external/mail/fileUpload';
    },
    editorOption() {
      return {
        configs: {
          saveHeightInStorage: false,
          allowResizeX: false,
          allowResizeY: true,
          toolbarButtonSize: 'large',
          enter: 'BR',
          colorPickerDefaultTab: 'color',
          showTooltip: false,
          showXPathInStatusbar: false,
          showWordsCounter: false,
          showCharsCounter: true,
          language: 'ko',
          i18n: {
            ko: {
              'Type something': '메세지를 입력하세요.',
              Bold: '굵게',
              'Drop image': '파일을 여기에 놓거나',
              'or click': '클릭하세요'
            }
          },
          enableDragAndDropFileToEditor: true,
          uploader: {
            url: process.env.BASE_URL + this.apiURL,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            isImages: false,
            fileName: '',
            prepareData: this.useExternalFileUploadAPI
              ? (formData) => {
                  formData.delete('path');
                  formData.delete('source');
                  formData.append('brandId', this.brandId);
                  return formData;
                }
              : (formData) => {
                  formData.append('loginId', 'emilEditor');
                  return formData;
                },
            filesVariableName: this.useExternalFileUploadAPI
              ? (i) => {
                  return 'file';
                }
              : (i) => {
                  return `files[${i}]`;
                },
            isSuccess: (resp) => {
              return resp.code === 0;
            },
            error: function () {
              this.jodit.events.fire('errorMessage', '파일 업로드를 실패했습니다.');
            },
            defaultHandlerSuccess: this.useExternalFileUploadAPI
              ? function (data) {
                  // mac에서 작성한 한글 파일의경우 자음, 모음 따로 배열처럼 저장돼 normalize사용, 다만 익스플로러는 지원하지않아 그냥 이름 사용
                  const browser = navigator.userAgent.toLowerCase();
                  const IEcheck =
                    (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || browser.indexOf('msie') !== -1;

                  /* 다충 코드 처리
                  data.forEach((k) => {
                    // image tag 삽입
                    if (k.isImage) {
                      const imgElm = this.jodit.create.element('img')
                      imgElm.setAttribute('src', k.url)
                      this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth)
                    } else {
                      try {
                        const elm = this.jodit.create.element('a')
                        let fileName = Helpers.editExtensionRemove(k.fileOriginalName)
                        elm.setAttribute('href', k.url)
                        elm.setAttribute('target', '_blank')
                        this.jodit.selection.insertNode(elm)
                        elm.textContent = IEcheck ? fileName : fileName.normalize('NFC')
                      } catch (e) {
                        console.log(e)
                      }
                    }
                    this.jodit.selection.insertNode(this.jodit.create.element('br'))
                    this.jodit.selection.insertNode(this.jodit.create.element('br'))
                  })
                */
                  // 단일 업로드 변경------------------------------------------------------
                  // image tag 삽입
                  try {
                    const dataObject = data[0];
                    const dataUrl = dataObject.filePath;
                    const isImage = dataObject.fileType.indexOf('image') !== -1;
                    const originalFileName = dataObject.fileOriginalName;
                    const elm = this.jodit.create.element('a');
                    elm.setAttribute('href', dataUrl);
                    elm.setAttribute('target', '_blank');
                    this.jodit.selection.insertNode(elm);

                    if (isImage) {
                      const imgElm = this.jodit.create.element('img');
                      imgElm.setAttribute('src', dataUrl);
                      this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth);
                      elm.appendChild(imgElm);
                    } else {
                      try {
                        let fileName = Helpers.editExtensionRemove(originalFileName);
                        elm.textContent = IEcheck ? fileName : fileName.normalize('NFC');
                      } catch (e) {
                        console.log(e);
                      }
                    }
                    this.jodit.selection.insertNode(this.jodit.create.element('br'));
                    this.jodit.selection.insertNode(this.jodit.create.element('br'));
                  } catch (e) {
                    console.log('file error', e);
                  }
                  // 단일 업로드 ------------------------------------------------------------
                }
              : function (data) {
                  // mac에서 작성한 한글 파일의경우 자음, 모음 따로 배열처럼 저장돼 normalize사용, 다만 익스플로러는 지원하지않아 그냥 이름 사용
                  const browser = navigator.userAgent.toLowerCase();
                  const IEcheck =
                    (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || browser.indexOf('msie') !== -1;

                  /* 다충 코드 처리
                  data.forEach((k) => {
                    // image tag 삽입
                    if (k.isImage) {
                      const imgElm = this.jodit.create.element('img')
                      imgElm.setAttribute('src', k.url)
                      this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth)
                    } else {
                      try {
                        const elm = this.jodit.create.element('a')
                        let fileName = Helpers.editExtensionRemove(k.fileOriginalName)
                        elm.setAttribute('href', k.url)
                        elm.setAttribute('target', '_blank')
                        this.jodit.selection.insertNode(elm)
                        elm.textContent = IEcheck ? fileName : fileName.normalize('NFC')
                      } catch (e) {
                        console.log(e)
                      }
                    }
                    this.jodit.selection.insertNode(this.jodit.create.element('br'))
                    this.jodit.selection.insertNode(this.jodit.create.element('br'))
                  })
                */
                  // 단일 업로드 변경------------------------------------------------------
                  // image tag 삽입
                  try {
                    const dataUrl = data.url;
                    const isImage = data.isImage;
                    const originalFileName = data.fileOriginalName;
                    const elm = this.jodit.create.element('a');
                    elm.setAttribute('href', dataUrl);
                    elm.setAttribute('target', '_blank');
                    this.jodit.selection.insertNode(elm);

                    if (isImage) {
                      const imgElm = this.jodit.create.element('img');
                      imgElm.setAttribute('src', dataUrl);
                      this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth);
                      elm.appendChild(imgElm);
                    } else {
                      try {
                        let fileName = Helpers.editExtensionRemove(originalFileName);
                        elm.textContent = IEcheck ? fileName : fileName.normalize('NFC');
                      } catch (e) {
                        console.log(e);
                      }
                    }
                    this.jodit.selection.insertNode(this.jodit.create.element('br'));
                    this.jodit.selection.insertNode(this.jodit.create.element('br'));
                  } catch (e) {
                    console.log('file error', e);
                  }
                  // 단일 업로드 ------------------------------------------------------------
                }
          }
        }
      };
    },
    axzEditorOption() {
      return {
        configs: {
          saveHeightInStorage: false,
          allowResizeX: false,
          allowResizeY: true,
          toolbarButtonSize: 'large',
          enter: 'BR',
          colorPickerDefaultTab: 'color',
          showTooltip: false,
          showXPathInStatusbar: false,
          showWordsCounter: false,
          showCharsCounter: true,
          language: 'ko',
          i18n: {
            ko: {
              'Type something': '메세지를 입력하세요.',
              Bold: '굵게',
              'Drop image': '파일을 여기에 놓거나',
              'or click': '클릭하세요'
            }
          },
          enableDragAndDropFileToEditor: true,
          uploader: {
            process: (resp) => {
              return resp;
            },
            url: process.env.BASE_URL + '/api/axz/file-upload',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            },
            isImages: false,
            fileName: '',
            filesVariableName: function () {
              return 'files';
            },
            prepareData: (formData) => {
              formData.append('brandId', this.brandId);
              formData.append('axzFileType', 'VOC_TICKET');
              return formData;
            },
            isSuccess: (resp) => {
              return !!resp.length;
            },
            error: function () {
              this.jodit.events.fire('errorMessage', '파일 업로드를 실패했습니다.');
            },
            defaultHandlerSuccess: function (data) {
              // mac에서 작성한 한글 파일의경우 자음, 모음 따로 배열처럼 저장돼 normalize사용, 다만 익스플로러는 지원하지않아 그냥 이름 사용
              const browser = navigator.userAgent.toLowerCase();
              const IEcheck = (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || browser.indexOf('msie') !== -1;

              /* 다충 코드 처리
                    data.forEach((k) => {
                      // image tag 삽입
                      if (k.isImage) {
                        const imgElm = this.jodit.create.element('img')
                        imgElm.setAttribute('src', k.url)
                        this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth)
                      } else {
                        try {
                          const elm = this.jodit.create.element('a')
                          let fileName = Helpers.editExtensionRemove(k.fileOriginalName)
                          elm.setAttribute('href', k.url)
                          elm.setAttribute('target', '_blank')
                          this.jodit.selection.insertNode(elm)
                          elm.textContent = IEcheck ? fileName : fileName.normalize('NFC')
                        } catch (e) {
                          console.log(e)
                        }
                      }
                      this.jodit.selection.insertNode(this.jodit.create.element('br'))
                      this.jodit.selection.insertNode(this.jodit.create.element('br'))
                    })
                  */

              const getFileTypeFromUrl = (url) => {
                const ext = url.split('.').pop().toLowerCase().split('?')[0];

                const imageExt = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
                const videoExt = ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm'];
                const docExt = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
                const audioExt = ['mp3', 'wav', 'ogg'];

                if (imageExt.includes(ext)) return 'image';
                if (videoExt.includes(ext)) return 'video';
                if (docExt.includes(ext)) return 'document';
                if (audioExt.includes(ext)) return 'audio';

                return 'unknown';
              };

              // 단일 업로드 변경------------------------------------------------------
              // image tag 삽입
              try {
                const dataUrl = data[0].url;
                const isImage = getFileTypeFromUrl(dataUrl) === 'image';
                const originalFileName = data[0].name;
                const elm = this.jodit.create.element('a');
                elm.setAttribute('href', dataUrl);
                elm.setAttribute('target', '_blank');
                this.jodit.selection.insertNode(elm);

                if (isImage) {
                  const imgElm = this.jodit.create.element('img');
                  imgElm.setAttribute('src', dataUrl);
                  this.jodit.selection.insertImage(imgElm, null, this.jodit.options.imageDefaultWidth);
                  elm.appendChild(imgElm);
                } else {
                  try {
                    let fileName = Helpers.editExtensionRemove(originalFileName);
                    elm.textContent = IEcheck ? fileName : fileName.normalize('NFC');
                  } catch (e) {
                    console.log(e);
                  }
                }
                this.jodit.selection.insertNode(this.jodit.create.element('br'));
                this.jodit.selection.insertNode(this.jodit.create.element('br'));
              } catch (e) {
                console.log('file error', e);
              }
              // 단일 업로드 ------------------------------------------------------------
            }
          }
        }
      };
    }
  },
  created() {
    this.mergeConfig();
  },
  methods: {
    mergeConfig() {
      const merge = (target, source) => {
        for (let key of Object.keys(source)) {
          if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]));
        }
        Object.assign(target || {}, source);
        return target;
      };
      if (this.useFileUploadAXZ) {
        merge(this.axzEditorOption, this.setConfigs);
      } else {
        merge(this.editorOption, this.setConfigs);
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/JoditEditor.vue